import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";

const initialState: CarSelectQuickInfoData = {
  frontTantoushaCd: null,
  isImportCar: null,
  keikaShareki: null,
  srPlateAreaCd: null,
  srPlateModelNm: null,
  srPlateKanaNm: null,
  srPlateNo: null,
  sknQuickMitsumoriId: null,
  laborRateCd: null,
  laborRateKingakuZn: null,
};

const actions: ActionTree<CarSelectQuickInfoData, any> = {
  setState(
    { commit }: ActionContext<CarSelectQuickInfoData, any>,
    payload: CarSelectQuickInfoData
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<CarSelectQuickInfoData, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: CarSelectQuickInfoData, payload: CarSelectQuickInfoData) {
    Object.assign(state, payload);
  },
  clearState(state: CarSelectQuickInfoData) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<CarSelectQuickInfoData, any> = {
  currentState(state: CarSelectQuickInfoData): any {
    return state;
  },
  /** 2021-07-29 sh #6989 implements quick mitsumori.(priority 2) [START] */
  currentStateSknQuickMitsumoriId(state: CarSelectQuickInfoData): any {
    if ( state.sknQuickMitsumoriId ) {
      return state.sknQuickMitsumoriId;
    }
    return null;
  }
  /** 2021-07-29 sh #6989 implements quick mitsumori.(priority 2) [END] */
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
